module.exports = __webpack_public_path__ + "static/img/xssc3.7a16013c.png";